import React from 'react';
import '../../Styles/Dashboard.scss';


export default function Dashboard__Kpi(props) {
    return (
        <React.Fragment>
            
            <div className="dashboard__kpi">
                <i class="material-icons dashboard__kpi-icon">{props.materialIcon}</i>
                <div className="dashboard__kpi-metrics-wrapper">
                    <div className="dashboard__kpi-metric">
                        15852
                    </div>
                    <div className="dashboard__kpi-metric-name">
                        {props.kpiName}
                    </div>
                </div>
            </div>
            
        </React.Fragment>
    );
}